import { IMAGE_URL } from '../lib/config';

/**
 * Upload an image file to R2 via the API Worker.
 * Returns the public URL of the uploaded image.
 */
export async function uploadImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  // Upload via API Worker (which stores to R2)
  const token = await (window as any).Clerk?.session?.getToken();
  const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};

  const res = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.villakosh.in'}/upload`, {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!res.ok) {
    throw new Error('Image upload failed');
  }

  const { fileId } = await res.json();
  return getImageUrl(fileId);
}

/**
 * Construct the public image URL for a given file ID.
 */
export function getImageUrl(fileId: string): string {
  return `${IMAGE_URL}/files/${fileId}`;
}

/**
 * Upload multiple images and return their URLs.
 */
export async function uploadImages(files: File[]): Promise<string[]> {
  return Promise.all(files.map(uploadImage));
}
